module.exports = __webpack_public_path__ + "img/bg-inteior-mobile.f5ca44a0.jpg";